import { FuseAnimate } from "@fuse";
import _ from "@lodash";
import { MenuItem, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import { generateRange } from "app/Core/Helpers";
import * as AppActions from "app/store/actions";
import withReducer from "app/store/withReducer";
import clsx from "clsx";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/TarefaApontamentoActions";
import TarefaApontamentoReducer from "./Store/Reducers/TarefaApontamentoReducer";

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
    },
    noBorder: {
        borderBottom: "0px"
    },
    bgLineHeader: {
        backgroundColor: theme.palette.type === "dark" ? "#303030" : "#666"
    },
    bgLineDetails: {
        backgroundColor: theme.palette.type === "dark" ? "#666" : "#F2F2F2"
    },
    colorHeader: {
        color: "#CCC"
    }
});

class TarefaApontamentoPedidoEmAberto extends XAPPComponent {

    componentDidMount() {
        const { listEmAberto, idtarefaprocesso, xappRouteParams, idpessoaformulario } = this.props;
        listEmAberto(xappRouteParams, { idtarefaprocesso, idpessoaformulario });
    }

    componentDidUpdate() {
        const { pedidoquantidade = null, TarefaApontamento, onChange = null } = this.props;
        if (TarefaApontamento.error) {
            this.props.showMessage({
                message: TarefaApontamento.error,
                variant: "error",
            });
            TarefaApontamento.error = null;
        }
        if (TarefaApontamento.warning) {
            this.props.showMessage({
                message: TarefaApontamento.warning,
                variant: "warning",
            });
            TarefaApontamento.warning = null;
        }
        if (TarefaApontamento.info) {
            this.props.showMessage({
                message: TarefaApontamento.info,
                variant: "success",
            });
            TarefaApontamento.info = null;
        }

        if (!_.isNull(onChange) && _.isNull(pedidoquantidade) && !_.isNull(this.getPedidoUnico())) {
            onChange(null, this.getPedidoUnico());
        }
    }

    getPedidoUnico = () => {
        const { idtarefaprocesso } = this.props;
        const APedidos = this.getApontamentos(idtarefaprocesso);
        let AArray = {};
        APedidos.forEach(pedido => {
            AArray = { ...AArray, ...((pedido.itens.filter(item => item.quantidade === 1)).map(item => item.idtarefaprocessoapontamentoitem)).reduce((item, x) => (item[x] = 1, item), {}) };
        });
        return AArray;
    };

    getApontamentos = (idtarefaprocesso = null) => {
        const { pedidos = null, data = null } = this.props.TarefaApontamento;
        if (!_.isNull(idtarefaprocesso)) {
            return !_.isNull(data) ? data : [];
        }
        return !_.isNull(pedidos) ? pedidos : [];
    };

    getColumnsItens = () => {
        const { readOnly = false, automaticUpdate = false } = this.props;
        const Columns = [
            {
                Header: "Nome",
                accessor: "nome",
                align: "start",
                className: "w-360"
            },
            {
                Header: "Qtd",
                accessor: "quantidade",
                align: "center",
            },
            {
                Header: "Total realizado",
                accessor: "quantidaderealizado",
                align: "center",
                editable: automaticUpdate && !readOnly
            },
            {
                Header: "Realizado agora",
                accessor: "quantidaderealizado",
                align: "center",
                editable: true,
                show: !automaticUpdate && !readOnly
            },
            {
                Header: "Recebido",
                accessor: "icon_recebido",
                align: "center"
            }
        ];
        return Columns.filter(x => ((_.isUndefined(x.show) || x.show)));
    };

    getColumns = () => {
        const Columns = [
            {
                Header: "ID",
                accessor: "idtarefaprocessoapontamento",
                align: "center",
            },
            {
                Header: "Nome",
                accessor: "nome",
                align: "center",
            },
            {
                Header: "Competência",
                accessor: "competenciadescricao",
                align: "center"
            }
        ];
        return Columns;
    };

    getEditableField = (_AColumn, _AItem) => {
        const { onChange, pedidoquantidade = {}, automaticUpdate = false, saveItem, xappRouteParams, idtarefaprocesso, idpessoaformulario } = this.props;
        switch (_AColumn.accessor) {
            case "quantidaderealizado":
                return (
                    <React.Fragment>
                        {automaticUpdate ?
                            <TextField
                                className="w-full"
                                key={"quantidaderealizado"}
                                name={"quantidaderealizado"}
                                value={_AItem.quantidaderealizado}
                                onChange={ev => saveItem("ALTERAR-QUANTIDADE-REALIZADO", { ..._AItem, "quantidaderealizado": ev.target.value }, xappRouteParams, { idtarefaprocesso, idpessoaformulario })}
                                fullWidth
                                select
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            >
                                {generateRange(_AItem.quantidade, true).map(x => (
                                    <MenuItem key={x} value={x}>{"" + x}</MenuItem>
                                ))}
                            </TextField>
                            :
                            <TextField
                                className="w-full"
                                key={"quantidaderealizado"}
                                name={"quantidaderealizado"}
                                value={pedidoquantidade[_AItem.idtarefaprocessoapontamentoitem] ?? 0}
                                onChange={ev => onChange({ ..._AItem, "quantidaderealizado": ev.target.value })}
                                fullWidth
                                select
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            >
                                {generateRange(_AItem.quantidade - _AItem.quantidaderealizado, true).map(x => (
                                    <MenuItem key={x} value={x}>{"" + x}</MenuItem>
                                ))}
                            </TextField>
                        }
                    </React.Fragment>
                );
        }
    };

    getIconDetalhe = (_AColumn, _AValue) => {
        switch (_AColumn.accessor) {
            case "icon_recebido":
                if (_AValue.hastitulo === 1) {
                    return (
                        <XAPPButton
                            type="Icon"
                            className="h-32 w-32 p-6 noHover"
                            variant="contained"
                            color="primary"
                            onClick={() => { }}
                            iconProps={"justify-center text-green"}
                            icon={"done"}
                        />
                    );
                }
                else {
                    return (
                        <XAPPButton
                            type="Icon"
                            className="h-32 w-32 p-6 noHover"
                            variant="contained"
                            color="primary"
                            onClick={() => { }}
                            iconProps={"justify-center text-grey"}
                            icon={"timer"}
                        />
                    );
                }

            default: return <div />;
        }
    };

    renderTable = (_ADados = []) => {
        const { classes, readOnly = false, get, xappRouteParams } = this.props;
        return (
            <React.Fragment>
                <FuseAnimate animation="transition.slideUpIn" delay={300}>
                    <Table className="min-w-full" aria-labelledby="tableTitle">
                        <TableBody>
                            {_.orderBy(_ADados, "competencia", "desc").map((n, x) => {
                                return (
                                    <React.Fragment key={x}>
                                        <TableRow className={clsx(n.statusregistro === 1 && !readOnly && "cursor-pointer", classes.bgLineHeader)} >
                                            {this.getColumns().map((column, y) => (
                                                <TableCell
                                                    key={y}
                                                    component="th"
                                                    scope="row"
                                                    className={classes.colorHeader}
                                                    align={column.align}
                                                    style={{ padding: "2px 12px 2px 12px", fontWeight: "bold" }}
                                                    onClick={() => { !column.accessor.includes("icon_") && n.statusregistro === 1 && !readOnly && get("SELECIONAR", xappRouteParams, n.idtarefaprocessoapontamento); }}
                                                >
                                                    {n[column.accessor]}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                        {n.itens !== null && n.itens.length > 0 &&
                                            <TableRow className={clsx("h-32", classes.bgLineDetails)}>
                                                <TableCell colSpan={this.getColumns().length}>
                                                    <Table className={"min-w-full"} aria-labelledby="tableTitle">
                                                        <TableHead>
                                                            <TableRow className="h-32">
                                                                {this.getColumnsItens().map(column => (
                                                                    <TableCell
                                                                        key={column.accessor}
                                                                        align={"center"}
                                                                        style={{ padding: "2px 12px 2px 12px", fontWeight: "bold" }}
                                                                    >
                                                                        {column.Header}
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {_.sortBy(n.itens, [x => -x.statusregistro]).map((m, z) => (
                                                                <TableRow key={z} className={clsx("h-32", m.statusregistro === 0 && "line-through")}>
                                                                    {this.getColumnsItens().map((column, q) => (
                                                                        <TableCell
                                                                            key={q}
                                                                            className={clsx(classes.noBorder, column.className)}
                                                                            component="th"
                                                                            scope="row"
                                                                            align={column.align}
                                                                            style={{ padding: "2px 12px 2px 12px" }}
                                                                        >
                                                                            {column.accessor.includes("icon_") ? (
                                                                                this.getIconDetalhe(column, m, n)
                                                                            ) : (
                                                                                <React.Fragment>
                                                                                    {column.editable ? (
                                                                                        this.getEditableField(column, m, n)
                                                                                    ) : (
                                                                                        m[column.accessor]
                                                                                    )}
                                                                                </React.Fragment>
                                                                            )}
                                                                        </TableCell>
                                                                    ))}
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableCell>
                                            </TableRow>
                                        }
                                    </React.Fragment>
                                );
                            })}
                        </TableBody>
                    </Table>
                </FuseAnimate>
            </React.Fragment>
        );
    };

    render() {
        const { idtarefaprocesso } = this.props;
        const APedidos = this.getApontamentos(idtarefaprocesso);
        const APedidosAberto = this.getApontamentos(null);
        return (
            <React.Fragment>
                {APedidos.length > 0 &&
                    <React.Fragment>
                        <Typography variant="h6" color="textSecondary" className="w-2/3 text-center my-6 mx-auto text-16">
                            {"Pedidos novos"}
                        </Typography>
                        {this.renderTable(APedidos)}
                    </React.Fragment>
                }
                {APedidosAberto.length > 0 &&
                    <React.Fragment>
                        <Typography variant="h6" color="textSecondary" className="w-2/3 text-center my-6 mx-auto text-16">
                            {"Pedidos em aberto"}
                        </Typography>
                        {this.renderTable(APedidosAberto)}
                    </React.Fragment>
                }
                {APedidos.length < 1 && APedidosAberto.length < 1 &&
                    <div className="flex flex-col flex-1 items-center justify-center p-16">
                        <div className="max-w-512 text-center">
                            <Typography variant="h6" color="textSecondary" className="mb-16">
                                {"Não existem registros cadastrados!"}
                            </Typography>
                        </div>
                    </div>
                }
            </React.Fragment>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        get: Actions.get,
        openReciboDialog: Actions.openReciboDialog,
        acaoRegistroItem: Actions.acaoRegistroItem,
        listEmAberto: Actions.listEmAberto,
        showMessage: AppActions.showMessage,
        saveItem: Actions.saveItem,
    }, dispatch);
}

function mapStateToProps({ auth, TarefaApontamento }) {
    return {
        TarefaApontamento: TarefaApontamento,
        sistemas: auth.user.data.settings.sistemas,
    };
}

export default withReducer("TarefaApontamento", TarefaApontamentoReducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(TarefaApontamentoPedidoEmAberto))));
